import type { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import type { TAPIOptions } from 'src/constants/apis/types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_WARBOX_MESSAGES } from '../constants/actions';
import type { TWarboxMessageActionTypes } from '../types';
import type { IMessage } from 'src/interfaces/message';

export const getMessages = async (
    dispatch: Dispatch<TWarboxMessageActionTypes>,
    filters: Record<string, unknown> = {},
    options: TAPIOptions = {
        isReadPermissionNecessary: false,
        select: '',
        populate: [],
    }
): Promise<void> => {
    dispatch({ type: SET_LOADING });

    try {
        const config = HEADERS({
            isReadPermissionNecessary:
                options.isReadPermissionNecessary ?? false,
        });
        const res = await ApiV2.get('/conversations/messages', {
            ...config,
            params: filters,
        });

        const messages: IMessage[] = res.data?.data ?? [];
        const total =
            res.data?.pagination?.total ?? res.data?.count ?? messages.length;

        dispatch({
            type: GET_WARBOX_MESSAGES,
            payload: { messages, total },
        });
    } catch (error) {
        dispatch({
            type: GET_WARBOX_MESSAGES,
            payload: { messages: [], total: 0 },
        });

        if (error instanceof Error) dispatch(handleError(error));
    }
};
